module.exports = __webpack_public_path__ + "static/media/by_eficience.13895502.png";